(()=>{
  const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2});
  function readClientRates(){
    const root=document.querySelector('[data-it-calc-root]');
    if(!root)return{};
    const out={};
    root.querySelectorAll('[data-fine-rate]').forEach(el=>{
      const metal=el.dataset.fineRate;
      const value=parseFloat((el.textContent||'').replace(/[^0-9.]/g,''));
      if(Number.isFinite(value)&&value>0)out[metal]=value;
    });
    return out;
  }
  function fillMatrix(){
    const cfg=document.querySelector('[data-it-authority-config]');
    const client=readClientRates();
    const rates={
      gold:client.gold||parseFloat(cfg?.dataset.ssrGold),
      silver:client.silver||parseFloat(cfg?.dataset.ssrSilver)
    };
    document.querySelectorAll('[data-authority-value]').forEach(el=>{
      const rate=rates[el.dataset.metal],weight=+el.dataset.weight,purity=+el.dataset.purity;
      if(Number.isFinite(rate)&&rate>0)el.textContent=money.format(rate*weight*purity);
      else el.textContent='Unavailable';
    });
  }
  function drawChart(days){
    const holder=document.querySelector('[data-history-chart]'),source=document.querySelector('[data-it-history]');
    if(!holder||!source)return;
    let rows=[];
    try{rows=JSON.parse(source.textContent||'[]');}catch(_){rows=[];}
    if(!Array.isArray(rows))rows=[];
    const cutoff=Date.now()-days*86400000;
    rows=rows.filter(row=>{const t=Date.parse(row.date||row.timestamp||'');return Number.isFinite(t)&&t>=cutoff;}).sort((a,b)=>Date.parse(a.date||a.timestamp)-Date.parse(b.date||b.timestamp));
    const empty=holder.querySelector('[data-history-empty]'),canvas=holder.querySelector('canvas');
    if(rows.length<2){
      if(canvas)canvas.hidden=true;
      if(empty){empty.hidden=false;empty.textContent=rows.length===1?'Historical tracking has started. The chart will appear after a second genuine daily snapshot is stored.':'Historical tracking will populate automatically as genuine daily server snapshots are collected. No historical values are fabricated.';}
      return;
    }
    if(empty)empty.hidden=true;
    if(!canvas)return;
    canvas.hidden=false;
    const dpr=Math.max(1,Math.min(2,window.devicePixelRatio||1)),cssW=Math.max(320,canvas.clientWidth||900),cssH=300;
    canvas.width=cssW*dpr;canvas.height=cssH*dpr;
    const c=canvas.getContext('2d');c.scale(dpr,dpr);c.clearRect(0,0,cssW,cssH);
    const pad={l:52,r:22,t:22,b:34},series=[['gold','#103448'],['silver','#66727d']],vals=[];
    rows.forEach(row=>series.forEach(([key])=>{const value=+row[key];if(Number.isFinite(value))vals.push(value);}));
    if(!vals.length)return;
    const min=Math.min(...vals),max=Math.max(...vals),span=Math.max(.0001,max-min);
    c.font='12px sans-serif';c.fillStyle='#566273';c.strokeStyle='#dde3e8';c.lineWidth=1;
    for(let i=0;i<=4;i++){
      const y=pad.t+(cssH-pad.t-pad.b)*i/4;c.beginPath();c.moveTo(pad.l,y);c.lineTo(cssW-pad.r,y);c.stroke();
      const value=max-span*i/4;c.fillText('£'+value.toFixed(value<10?2:0),4,y+4);
    }
    series.forEach(([key,color])=>{
      const points=rows.map((row,i)=>({v:+row[key],x:pad.l+(cssW-pad.l-pad.r)*(rows.length===1?0:i/(rows.length-1))})).filter(point=>Number.isFinite(point.v));
      if(points.length<2)return;
      c.strokeStyle=color;c.lineWidth=2;c.beginPath();
      points.forEach((point,i)=>{const y=pad.t+(max-point.v)/span*(cssH-pad.t-pad.b);if(i===0)c.moveTo(point.x,y);else c.lineTo(point.x,y);});
      c.stroke();
    });
    c.fillStyle='#121826';c.fillText('Gold £/g',pad.l,cssH-9);c.fillStyle='#66727d';c.fillText('Silver £/g',pad.l+90,cssH-9);
  }
  function boot(){
    fillMatrix();
    document.addEventListener('imperial:precious-rates',fillMatrix);
    setTimeout(fillMatrix,1200);
    document.querySelectorAll('[data-history-range]').forEach(button=>button.addEventListener('click',()=>{
      document.querySelectorAll('[data-history-range]').forEach(other=>other.classList.toggle('is-active',other===button));
      drawChart(+button.dataset.historyRange||30);
    }));
    drawChart(30);
    window.addEventListener('resize',()=>drawChart(+(document.querySelector('[data-history-range].is-active')?.dataset.historyRange||30)));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();